import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import LeafForHeader from '../../../assets/leafForHeader.svg';
import Logo from '../../../assets/logoWhite.svg';
import { ButtonContainer } from '../../../components/Buttons/BottomButton';
import { onWebAppViewOrganizationLandingPage } from '../../../tracking/trackers';
import { useAmplitude } from '../../../providers/AmplitudeProvider';

const TeamsLanding = ({ onCTAClick }: { onCTAClick?: () => void }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { isInitialized } = useAmplitude();
    const isMobile = useMediaQuery('(max-width: 900px)');

    useEffect(() => {
        if (isInitialized) {
            onWebAppViewOrganizationLandingPage({
                url: location.pathname,
            });
        }
    }, [isInitialized]);

    const onCTAClickHandler = () => {
        if (onCTAClick) {
            onCTAClick();
        } else {
            navigate('/signup?manualCodeEntry=true&variant=organization');
        }
    };

    return (
        <div
            style={{
                width: '100%',
            }}
        >
            <img
                src={LeafForHeader}
                alt=""
                width={500}
                style={{
                    position: 'absolute',
                    right: 0,
                }}
            />
            <div style={{ margin: 'auto' }}>
                <div
                    style={{
                        width: '100%',
                        height: '100vh',
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        alignItems: 'center',
                        backgroundColor: '#181C3F',
                        padding: '5%',
                    }}
                >
                    <div
                        style={{
                            width: isMobile ? '100%' : '50%',
                            flex: 1,
                        }}
                    >
                        <img src={Logo} alt="logo" width={200} />
                        <div style={{ marginTop: 25 }} />
                        <div
                            style={{
                                fontWeight: 'bold',
                                fontSize: '3.5rem',
                                color: 'white',
                            }}
                        >
                            For Teams
                        </div>
                        <div
                            style={{
                                fontWeight: 'bold',
                                fontSize: '2rem',
                                marginTop: 10,
                                color: 'white',
                            }}
                        >
                            with a ton of receipts.
                        </div>
                    </div>
                    <div
                        style={{
                            width: isMobile ? '100%' : '50%',
                            flex: 1,
                            paddingBottom: 40,
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: 'white',
                                borderRadius: 10,
                                padding: 20,
                                boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.1)',
                                // fontWeight: 'bold',
                                color: '#181C3F',
                            }}
                        >
                            Remind employees to submit their receipts on time
                        </div>
                        <div style={{ margin: 5 }} />
                        <div
                            style={{
                                backgroundColor: 'white',
                                borderRadius: 10,
                                padding: 20,
                                boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.1)',
                                // fontWeight: 'bold',
                                color: '#181C3F',
                            }}
                        >
                            Reconcile expenses with credit cards
                        </div>
                        {/* <div style={{ margin: 5 }} />
                        <div
                            style={{
                                backgroundColor: 'white',
                                borderRadius: 10,
                                padding: 20,
                                boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.1)',
                                // fontWeight: 'bold',
                                color: '#181C3F',
                            }}
                        >
                            Sync with QuickBooks
                        </div> */}
                    </div>
                </div>
                <div
                    style={{
                        width: '100',
                        height: '100vh',
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        alignItems: 'center',
                        // only top gradient from #181C3F to #F5F5F5
                        background: `linear-gradient(180deg, #F5F5F5 0%, #F5F5F5 25%, #F5F5F5 100%)`,
                        padding: '10%',
                    }}
                >
                    <div
                        style={{
                            width: isMobile ? '100%' : '50%',
                            fontWeight: 'bold',
                            fontSize: 24,
                            flex: 1,
                        }}
                    >
                        <div>1. Unlimited storage</div>
                        <div>2. Unlimited connected bank accounts</div>
                        <div>3. Across any platform</div>
                    </div>
                    <div
                        style={{
                            width: isMobile ? '100%' : '50%',
                            justifyContent: 'center',
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            paddingBottom: 40,
                        }}
                    >
                        <div
                            style={{
                                fontWeight: 'bold',
                                fontSize: 56,
                            }}
                        >
                            $89.99
                        </div>
                        <div style={{ margin: 5 }} />
                        <div>year/employee</div>

                        <div style={{ margin: 20 }} />

                        <ButtonContainer onClick={() => onCTAClickHandler()}>
                            <div
                                style={{
                                    fontWeight: 'bold',
                                    fontSize: 24,
                                    color: 'white',
                                }}
                            >
                                Get Started
                            </div>
                        </ButtonContainer>
                        <div
                            style={{
                                color: 'gray',
                                fontSize: 12,
                                fontWeight: 'bold',
                            }}
                        >
                            1 week free trial
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TeamsLanding;
